import { AlertColor } from '@mui/material/Alert';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { constants } from 'utils/constants';

interface InitialGlobalState {
	authToken: string;
	errorMessage: { message: string };
	isAlertModalVisible: boolean;
	isMobile: boolean;
	loader: number;
	snackbarSeverity: AlertColor;
	snackbarMessage: string;
}

const initialState: InitialGlobalState = {
	authToken: '',
	errorMessage: { message: '' },
	isAlertModalVisible: false,
	isMobile: false,
	loader: 0,
	snackbarSeverity: 'success',
	snackbarMessage: '',
};

export const globalSlice = createSlice({
	name: 'global',
	initialState: initialState,
	reducers: {
		setIsAlertModalVisible: (state, action: PayloadAction<boolean>) => {
			state.isAlertModalVisible = action.payload;
		},
		setIsMobileView: (s, a) => {
			const breakpoint = `${constants('desktopBreakPoint')}`;
			s.isMobile = a.payload < parseInt(breakpoint, 10);
		},
		setLoaderOn: (state) => {
			state.loader += 1;
		},
		setLoaderOff: (state) => {
			state.loader = state.loader > 0 ? state.loader - 1 : 0;
		},
		setErrorMessage: (state, action: PayloadAction<string>) => {
			state.errorMessage.message = action.payload;
		},
		setAuthToken: (state, action: PayloadAction<string>) => {
			state.authToken = action.payload;
		},
		setSnackbarSeverity: (state, action: PayloadAction<AlertColor>) => {
			state.snackbarSeverity = action.payload;
		},
		setSnackbarMessage: (state, action: PayloadAction<string>) => {
			state.snackbarMessage = action.payload;
		},
	},
});

export const {
	setErrorMessage,
	setIsAlertModalVisible,
	setIsMobileView,
	setLoaderOn,
	setLoaderOff,
	setAuthToken,
	setSnackbarSeverity,
	setSnackbarMessage,
} = globalSlice.actions;

export default globalSlice.reducer;
